import {IonCardContent, IonCardTitle} from "@ionic/react";
import {LngLat} from "maplibre-gl";
import {IRouteProps} from "../../../ts/manager/view/ViewInterface";
import {getModelFactory} from "../../../ts/model-factory/ModelFactory";
import {LocatableDataChoice} from "../../../ts/data/locate/LocatableDataFactory";
import RouteChoiceButton from "../../element/button/RouteChoiceButton";
import LocatePageListPage from "../locate/LocatePageListPage";
import {PostType} from "../../../ts/manager/post/PostManager";
import {getManager} from "../../../ts/manager/Manager";
import React from "react";
import {PostDataChoice} from "../../../ts/data/subject/PostDataFactory";
import StateViewController from "../../vc/StateViewController";
import {assert} from "../../../ts/common/Assert";

const PostLocatePageListPage = (props:IRouteProps) =>
{
    const postType:PostType = getManager().navigation.model.routeIDs.post_type ?? "organisation";
    const routeModel = getModelFactory().postListRoute.getDefaultModel(postType);

    const viewState = StateViewController({
        routeProps: props,
        assert: routeModel
    })

    if(viewState.overrideView){
        return viewState.overrideView;
    }
    assert(routeModel);

    const getCardContent = (locateChoice:LocatableDataChoice, fromLngLat:LngLat|null):React.JSX.Element|null =>
    {

        const choice = locateChoice as PostDataChoice
        const postRoute = choice ? (routeModel.choices[choice.id] ?? null) : null;
        if (!postRoute)
        {
            return null;
        }
        let distance = fromLngLat ? locateChoice.getReadableDistance(fromLngLat) : null;
        distance = distance ? distance : "Unknown distance"

        let address = choice.addressVO.town;
        if (choice.addressVO.county)
        {
            address = address ? address + ", " : "";
            address += choice.addressVO.county;
        }
        if (choice.addressVO.countryName)
        {
            address = address ? address + ", " : "";
            address += choice.addressVO.countryName;
        }
        const content = address ?
            <IonCardContent>
                {address}
            </IonCardContent> :
            <></>;

        return <>
            <IonCardTitle>
                {choice.name}
            </IonCardTitle>
            {content}
            <RouteChoiceButton
                key={postRoute.realPath}
                routeChoice={postRoute}
                className="btn btn-primary"
            >
                View
            </RouteChoiceButton>
        </>
    }

    return <LocatePageListPage
        {...props}
        getCardContent={getCardContent}
        returnType="basic_reference_object"
    />
}

export default PostLocatePageListPage;